export const additionalInformationTypeCodeDescriptionMap = {
  ADTX: "Additional Text",
  TXNR: "Narrative Version",
};

export const adjustmentTypeCodeDescriptionMap = {
  CCHA: "Capital Change Type",
  REPO: "LSEG Pricing Only",
  RETS: "Timeseries, provided by LSEG",
};

export const amountStatusCodeDescriptionMap = {
  ACTU: "Actual amount",
  APPX: "Approximate interim",
  ARPM: "Arrears payment",
  FORR: "Forecast regular",
};

export const derivationTypeCodeDescriptionMap = {
  AUTO: "Automatically derived Annualization Type",
  MAN: "Manually calculated Annualization Type",
};

export const creditDebitIndicatorDescriptionMap = {
  CRED: "Credit Amount",
  DEBT: "Debit Amount",
};

export const dispositionOfFractionsCodeDescriptionMap = {
  BUYU: "Buy Up",
  CINL: "Fractional Part for Cash",
  DIST: "Distributed",
  RDDN: "Round down",
  RDUP: "Round up",
  STAN: "Standard",
};

export const distributionTaxTypeCodeDescriptionMap = {
  APUS: "Applicable to U.S. Residents",
  CFIN: "Conduit Foreign Income",
  FLFR: "Fully Franked",
  FOIN: "Foreign Income Dividend",
  FWTC: "Free of Withholding of tax to Non-Resident",
  INTF: "Includes Tax Credit",
  INTR: "Interest Income",
  IPTC: "Irish Imputation",
  SOIC: "Sundry Other Income",
  SPTC: "Special Tax Conditions",
  TAXC: "Tax Credit Rate",
  TAXR: "Withholding Tax Rate",
  TXDF: "Tax Deferred",
  UKIS: "UK Imputation System",
  UNFR: "Unfranked",
  WITA: "Withholding Tax",
};

export const distributionTypeCodeDescriptionMap = {
  EXTR: "Extra",
  FINL: "Final",
  INTE: "Interim",
  REGR: "Regular",
  SPEC: "Special",
};

export const eventActionCodeDescriptionMap = {
  CANC: "Cancelled",
  NEWM: "New",
  REPL: "Replacement",
  WITH: "Withdrawn",
};

export const eventStageCodeDescriptionMap = {
  APPD: "Approved",
  LAPS: "Lapsed",
  PROP: "Subject to approval",
  RESC: "Rescinded",
  RESD: "Event Rescinded",
  SUAP: "Subject to Approval",
};

export const eventTypeCodeDescriptionMap = {
  BIDS: "Repurchase Offer/Issuer Bid/Reverse Rights",
  BONU: "Bonus Issue/ Capitalisation Issue",
  CAPD: "Capital Distribution",
  CAPG: "Capital Gains Distribution",
  CMET: "Court meeting",
  CONV: "Conversion",
  DECR: "Decrease in Value",
  DRIP: "Dividend Reinvestment",
  DVCA: "Cash Dividend",
  DVOP: "Dividend Option",
  DVSE: "Stock Dividend",
  EXOF: "Exchange",
  EXRI: "Call on Intermediate Securities",
  INCR: "Increase in Value",
  LIQU: "Liquidation Dividend/ Liquidation Payment",
  MEET: "Annual general meeting",
  NOMV: "Nominal Value",
  ODLT: "Odd Lot Sale/Purchase",
  OMET: "Ordinary general meeting",
  OTHR: "Other event",
  PARI: "Pari-passu/Assimilation",
  PPMT: "Instalment Call",
  PRIO: "Priority Issue",
  REDO: "Redenomination",
  RHDI: "Intermediate Securities Distribution",
  RHTS: "Rights Issue/ Subscription Rights/ Rights Offer",
  SECC: "Shares",
  SHPR: "Shares Premium Dividend",
  SOFF: "Spin-Off",
  SPLF: "Stock Split/Change in Nominal Value/Subdivision",
  SPLR: "Reverse Stock Split/Change in Nominal Value",
  VOTR: "Voting rights",
  XMET: "Extraordinary or special general meeting",
};

export const mandatoryVoluntaryIndicatorDescriptionMap = {
  CHOS: "Choice",
  MAND: "Mandatory",
  VOLU: "Voluntary",
};

export const meetingTypeCodeDescriptionMap = {
  BDMT: "Board meeting",
  CMET: "Court meeting",
  MEET: "Annual general meeting",
  OMET: "Ordinary general meeting",
  XMET: "Extraordinary or special general meeting",
};

export const offerTypeCodeDescriptionMap = {
  OPMP: "Open Market Purchase",
  "ONMT - Non Iso": "On Market - Tender Offer",
  OFMT: "Off Market - Tender Offer",
  "ONMD - Non Iso": "On Market - Dutch Auction",
  OFMD: "Off Market - Dutch Auction",
  "ONMP - Non Iso": "On Market - Pro Rata",
  OFMP: "Off Market - Pro Rata",
  OFMI: "Off Market - Insider",
};

export const optionTypeCodeDescriptionMap = {
  BSPL: "Bonus Share Plan",
  BUYA: "Buy Up",
  CASE: "Cash and Securities",
  CASH: "Cash",
  EXER: "Exercise",
  LAPS: "Lapse",
  MPUT: "Retain",
  SECU: "Securities Option",
  OTHR: "Other",
  OVER: "Over subscription",
};

export const paymentFrequencyDescriptionMap = {
  ANNU: "Annual dividend",
  MNTH: "Monthly dividend",
  NOFR: "Dividend with no set frequency",
  SEMI: "Semi-annual dividend",
  THRI: "Thrice yearly",
  QRTR: "Quarterly dividend",
  WEEK: "Weekly dividend",
};

export const processingStatusDescriptionMap = {
  COMP: "Complete",
  INFO: "Information",
  PREC: "Preliminary Confirmed",
  PREU: "Preliminary Unconfirmed",
};

export const processingTypeCodeDescriptionMap = {
  DISN: "Distribution",
  GENL: "General",
  REOR: "Reorganisation",
};

export const qdiEligibilityCodeDescriptionMap = {
  FLQD: "Fully Qualified",
  PAQD: "Partially Qualified",
  UNKW: "Not Qualified",
  UNQD: "Unknown",
};

export const renounceableStatusDescriptionMap = {
  NREN: "Non-Renounceable",
  RENO: "Renounceable",
};

export const sourceOfFundsCodeDescriptionMap = {
  CARE: "Capital Reserves",
  CART: "Capital Return",
  DISA: "Disposal of Assets",
  OTHE: "Other Reserves",
  OTRE: "Other",
  REGP: "Regular Profit",
  RETP: "Retained Profit",
  SHRP: "Share Premium",
};

export const typeCodeDescriptionMap = {
  TTM: "Trailing Twelve Months",
  IAD: "Indicated Annual Dividend",
  LFY: "Latest Fiscal Year",
};

export const meetingStatusCodeDescriptionMap = {
  ANND: "Announced",
  CANL: "Cancelled",
  DEFN: "Definitive",
  NQAD: "No quorum achieved",
  PDPL: "Planned / Provisional",
  POSD: "Postponed",
};

export const meetingWebcastTypeCodeDescriptionMap = {
  ENHD: "Streaming Audio with Additional options",
  VEDO: "Streaming vedio with voice synchronised slides and HTML links",
  VIRL: "Streaming audio with voice synchronised slide presentation",
  BASC: "Streaming Audio",
  OTHR: "Publish an event using a third party product",
};

export const meetingAgendaTypeCodeDescriptionMap = {
  ANRP: "Annual report",
  AAFI: "Annual accounts/financial statement",
  ADRT: "Auditors report",
  ARDV: "Arrear dividends",
  ATMR: "Anti takeover measures",
  CBLA: "Change by-laws/Articles and memorandum of association",
  CBYR: "Change of business year",
  CCPP: "Change corporate purpose",
  CDVD: "Cash Dividend",
  CEQT: "Change of equity type",
  CFTA: "Controlling & profit transfer agreement",
  CGLN: "Change of location",
  CGNM: "Change of name",
  CIDS: "Capital increase, distribution of subscription",
  CLFM: "Change of legal form",
  CMBD: "Change of maturity",
  CPRD: "Capital reduction",
  CPVI: "Capital/par value increase",
  CPVR: "Capital/par value reduction",
  CVRG: "Change of voting rights",
  DBDT: "Discharge of BOD",
  DEMG: "Discharge of Executive Management",
  DGAD: "Discharge of Auditor",
  DLPD: "Distrib. of liquidation proceedings",
  DMRG: "Demerger",
  DSLQ: "Dissolution, Liquidation",
  ELBD: "Election of BOD",
  ELCA: "Election/confirmation of auditors",
  ELMG: "Election of Executive Management",
  ELPP: "Employees Participation Plan",
  ELTN: "Elections",
  ESCU: "Exchange of securities / Consolidation in units",
  ICFI: "Invalidation of coupons/financial instructions",
  ICSS: "Issuance of Shares",
  IVFI: "Issuance of various financial instruments.",
  LGPR: "Legal Proceeding",
  LSAD: "Loss Advice",
  MERG: "Merger",
  OFFF: "Offer",
  OTNT: "Other/See Note",
  PADS: "Profit appropriation/Dividend setting",
  PDSO: "Portfolio distribution (Spin-Off)",
  RBMM: "Remuneration of board members",
  RDMN: "Redenomination",
  RGRT: "Registration Restriction",
  RORG: "Reorganization",
  RPFS: "Redemption of pref. shares",
  RPSC: "Repurchase of proprietary securities",
  RTAC: "Retirement Allowance",
  RVSP: "Reverse Split",
  SCCG: "Sector Change",
  SPTT: "Split",
  SROF: "Special Rights Offered",
  STDV: "Stock Dividend",
  STON: "Stock options (shinkabu yoyaku-ken)",
  UNLY: "Use of net loss for the year",
};

export const distributionMarkerTypeCodeDescriptionMap = {
  EXTR: "Extra",
  FINL: "Final",
  INTE: "Interim",
  LTCG: "Long-term capital gains",
  REGR: "Regular",
  SPEC: "Special",
  STCG: "Short-term capital gains",
  ARPM: "Arrears payment",
  CAPG: "Capital gains",
  STCK: "Stock dividend, same stock",
  STDS: "Stock dividend, different stock",
  RESD: "Rescinded payment",
  APMS: "Approximate, miscellaneous",
  FOIN: "Forecast interim",
  FOFL: "Forecast final",
  APIN: "Approximate interim",
  APFL: "Approximate final",
  FOSL: "Forecast special",
  COFL: "Commemorative final",
  SPIN: "Special interim",
  COIN: "Commemorative interim",
  SPFL: "Special final",
  LIQU: "Liquidation",
};

export const sharesQuantityTypeCodeDescriptionMap = {
  AUT: "Authorised",
  CLH: "Closely Held",
  DIL: "Diluted",
  FFL: "Free Float",
  ISS: "Issued",
  LIS: "Listed",
  OUT: "Outstanding",
  TRE: "Treasury",
  UNC: "Unclassified",
};


